module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai62-659d664b0234bd64ec4f5a8315772a8a.jpg";